import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import API from "../../services/request";
import { API_PATH, QUERY_KEYS } from "../../utils/config";
import { isSignedIn } from "../../utils/loginRedirect";
import {
  hasPendingFavorite,
  takePendingFavorite,
} from "../../utils/pendingFavorite";

/**
 * T22.731: applies the favourite a guest asked for (heart -> sign-in gate ->
 * Log In) once they are signed in. Mounted once at the app root and re-checked
 * on every navigation, so it fires on whichever page login lands on.
 *
 * like-unlike is a TOGGLE, so the wheel's current state is read first: a wheel
 * the account already favourited is left alone instead of being un-favourited.
 */
const PendingFavoriteApplier = () => {
  const location = useLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isSignedIn() || !hasPendingFavorite()) return;
    const wheelId = takePendingFavorite();
    if (!wheelId) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await API.get(API_PATH.GET_WHEEL_DETIALS(wheelId));
        const wheel = res?.data?.data ?? res?.data;
        if (!wheel?.is_favourite) {
          await API.post(API_PATH.FAVORITE_WHEEL(wheelId));
        }
        if (cancelled) return;
        queryClient.invalidateQueries(["exploreV2Feed"]);
        queryClient.invalidateQueries(["fetchWheels"]);
        queryClient.invalidateQueries([QUERY_KEYS.useGetWheelSection, wheelId]);
        toast.success("Added to your favorites");
      } catch (e) {
        if (!cancelled) toast.error("Could not add that wheel to your favorites.");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.key, queryClient]);

  return null;
};

export default PendingFavoriteApplier;
